import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'completed-title',
    templateUrl: './completed.title.component.html',
    styleUrls: ['../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedTitleComponent {
    @Input('id') id;
    @Input('isHugeOrder') isHugeOrder;
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/completed/title/completed.title.component.ts